import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { ProviderValue, useAxios } from '../../config/axios-config';
import { Customer } from '../../model/Customer'
import { CustomerMeal } from '../../model/CustomerMeal'
import { Meal } from '../../model/Meal'
import { Col, Divider, List, Popconfirm } from 'antd'
import { IconButton, Tooltip, Zoom } from '@mui/material'
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Button, Modal } from 'react-bootstrap'
import { LocalDate } from 'local-date'
import dayjs from 'dayjs';
import 'dayjs/locale/pl'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { CustomerMealRequestDTO } from '../../model/CustomerMealRequestDTO';
import { CustomerMealResponseDTO, ResponsePattern } from '../../model/ResponsesDTO';
import { isMobile } from 'react-device-detect';
import { DinneyResponseStatus } from '../util/DinneyResponseStatus';

export const MealsToCustomerTransferModal : React.FC<{customer : Customer, 
    mealList : Meal[], index : number | null,
    showTransfer : boolean, setShowTransfer : Dispatch<SetStateAction<boolean>>
}> = (props) => {
    const axiosInstance = useAxios() as ProviderValue
    const {customer, mealList, index, showTransfer, setShowTransfer} = props
    const [allMeals, setAllMeals] = useState<Meal[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const controller = new AbortController();
    const signal = controller.signal

    useEffect(() => {
        if (mealList !== undefined) {
            setAllMeals(mealList.filter(meal => customer.customerMeals !== undefined && customer.customerMeals?.length > 0 ? !customer.customerMeals.filter(customerMeal => customerMeal.customermealEnd === null || dayjs(customerMeal.customermealEnd).isAfter(dayjs().startOf('month'))).map(customerMeal=>customerMeal.meal.mealid).includes(meal.mealid): mealList))
        }
    // eslint-disable-next-line
    },[showTransfer])

    const handleExit = () => {
        setShowTransfer(false)
    }

    const handleAdd = async (meal : Meal) => {
        setLoading(true)
        let beginDate = new LocalDate(dayjs(dayjs()).format('YYYY-MM-DD'))
        let requestCustomerMeal = new CustomerMeal(customer, meal, beginDate)
        let customermealRequestDTO = new CustomerMealRequestDTO(requestCustomerMeal, ResponsePattern.MEAL)
        let responseCustomerMeal : CustomerMeal | undefined
        await axiosInstance.post<CustomerMealResponseDTO>(`/customermeals/secure/save`, customermealRequestDTO, {signal}).then((response) => {
            responseCustomerMeal = response.data.customerMealForMealPattern
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        if (responseCustomerMeal !== undefined) {
            if (customer.customerMeals === undefined) {
                customer.customerMeals = []
            }
            customer.customerMeals.push(responseCustomerMeal)
            setAllMeals(mealList.filter(meal => !customer.customerMeals?.filter(customerMeal => customerMeal.customermealEnd === null || dayjs(customerMeal.customermealEnd).isAfter(dayjs().startOf('month'))).map(customerMeal=>customerMeal.meal.mealid).includes(meal.mealid)))
        }
        setLoading(false)
        return () => {
            controller.abort()
        }
    }

    const handleArchiveRestore = async (customerMeal : CustomerMeal, isArchive : boolean) => {
        setLoading(true)
        let endDate : LocalDate
        await axiosInstance.delete<CustomerMealResponseDTO>(`/customermeals/secure/${isArchive ? `archive` : `restore`}/${customerMeal.customermealid}`, {signal}).then((response) => {
            endDate = response.data.customermealEnd
            customerMeal.customermealEnd = endDate
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        setLoading(false)
        return () => {
            controller.abort()
        }
    }

    const handleDelete = async (customerMeal : CustomerMeal) => {
        setLoading(true)
        let responseStatus : DinneyResponseStatus | undefined
        await axiosInstance.delete<DinneyResponseStatus>(`/customermeals/secure/delete/${customerMeal.customermealid}`, {signal}).then((response) => {
            responseStatus = response.data
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        if (responseStatus !== undefined) {
            customer.customerMeals = customer.customerMeals!.filter(currentCustomerMeal => currentCustomerMeal.customermealid !== customerMeal.customermealid)
            setAllMeals(mealList.filter(meal => customer.customerMeals !== undefined && customer.customerMeals?.length > 0 ? !customer.customerMeals.filter(customerMeal => customerMeal.customermealEnd === null || dayjs(customerMeal.customermealEnd).isAfter(dayjs().startOf('month'))).map(customerMeal=>customerMeal.meal.mealid).includes(meal.mealid): mealList))
        }
        setLoading(false)
        return () => {
            controller.abort()
        }
    }

    return(
    <Modal key={index} size='xl' show={showTransfer} backdrop={'static'} onHide={() => handleExit()}>
        <Modal.Header closeButton>
        {isMobile ?
            <Modal.Title as='div'>{`${customer.firstName} ${customer.lastName} - Dodaj posiłki do rodzica`}</Modal.Title>
            :
            <Modal.Title>{`${customer.firstName} ${customer.lastName} (dziecko: ${customer.childName}) - Dodaj posiłki do rodzica`}</Modal.Title>
        }
        </Modal.Header>
        <Modal.Body>
        <Divider orientation="left">Wybrane posiłki</Divider>
        <List
            size="small"
            bordered
            loading ={loading}
            style= {customer.customerMeals !== undefined && customer.customerMeals?.length < 5 && customer.customerMeals?.length > 0 ? {minHeight: '30vh'} : {}}
            dataSource={customer.customerMeals !== undefined ? customer.customerMeals
                .filter(customerMeal => dayjs().startOf('month') < dayjs(customerMeal.customermealEnd) || customerMeal.customermealEnd === null) : []}
            pagination={{defaultCurrent: 1, pageSize: 4, showSizeChanger : false, position: 'top' }}
            renderItem={(currentCustomerMeal) => 
            <List.Item style={{paddingBlock: '0px'}}>
                <Col span={10}>{currentCustomerMeal.meal.details} 
                    {currentCustomerMeal.customermealEnd === null ? 
                    ""
                    :
                    <Tooltip title={`To połączenie rodzic-posiłek ma zostać zdeaktywowane 
                    (stało się tak w wyniku bezpośredniej deaktywacji połączenia lub w wyniku deaktywacji rodzica lub posiłku). Na tej stronie będzie ono widoczne 
                    do dnia ${currentCustomerMeal.customermealEnd}.`} 
                        arrow placement="right">
                        <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                    </Tooltip>
                    }
                </Col>
                <Col span={4}>{currentCustomerMeal.meal.amount} zł</Col>
                <Col span={2}>
                  { currentCustomerMeal.customermealEnd === null ?
                    <>
                    <Popconfirm
                    title="Deaktywuj połączenie rodzica z posiłkiem"
                    description="Na pewno chcesz deaktywować połączenie rodzic-posiłek?"
                    onConfirm={() => handleArchiveRestore(currentCustomerMeal, true)}
                    okText="Tak"
                    cancelText="Nie"
                    >
                    <Tooltip TransitionComponent={Zoom} title="Deaktywuj połączenie rodzica z posiłkiem">
                        <span>
                            <IconButton color="warning">
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    </Popconfirm>
                    </>
                    :
                    <>
                    <Popconfirm
                    title="Aktywuj połączenie rodzica z posiłkiem"
                    description="Na pewno chcesz aktywować połączenie rodzic-posiłek?"
                    onConfirm={() => handleArchiveRestore(currentCustomerMeal, false)}
                    okText="Tak"
                    cancelText="Nie"
                    >
                    <Tooltip TransitionComponent={Zoom} title={!currentCustomerMeal.meal.active ? `Nie można aktywować połączenia rodzica z posiłkiem ponieważ sam posiłek jest zdezaktywowany`: `Aktywuj połączenie rodzica z posiłkiem`}>
                        <span>
                            <IconButton color="warning" disabled={!currentCustomerMeal.meal.active}>
                                <RestoreFromTrashIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    </Popconfirm>
                    </>
                    }
                </Col>
                <Col span={2}>
                <Popconfirm
                    title="Usuń połączenie rodzica z posiłkiem"
                    description={<span style={{width:'200px', display: 'inline-block'}}>Na pewno chcesz usunąć połączenie rodzic-posiłek? Jeśli połączenie powstało w tym miesiącu, zostanie ono usunięte całkowicie. Jeśli powstało wcześniej, zostanie zdezaktywowane z datą na koniec poprzedniego miesiąca</span>}
                    onConfirm={() => handleDelete(currentCustomerMeal)}
                    okText="Tak"
                    cancelText="Nie"
                    >
                    <Tooltip TransitionComponent={Zoom} title="Usuń połączenie rodzica z posiłkiem">
                        <span>
                            <IconButton color="error">
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    </Popconfirm>
                </Col>
            </List.Item>
            }
        />
        <Divider orientation="left">Wszystkie dostępne posiłki</Divider>
        <List
            size="small"
            bordered
            style= {allMeals !== undefined && allMeals?.length < 5 && allMeals?.length > 0 ? {minHeight: '30vh'} : {} }
            loading ={loading}
            dataSource={allMeals}
            pagination={{defaultCurrent: 1, pageSize: 4, showSizeChanger : false, position: 'top' }}
            renderItem={(meal) => 
            <List.Item style={{paddingBlock: '0px'}}>
                <Col span={10}>{meal.details} </Col>
                <Col span={6}>{meal.amount} zł</Col>
                <Col span={2}>
                  <Tooltip TransitionComponent={Zoom} title="Dodaj do posiłków rodzica">
                    <IconButton onClick ={() => handleAdd(meal)}>
                    <AddCircleIcon color="success" />
                    </IconButton>
                  </Tooltip>
                </Col>
            </List.Item>
            }
        />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleExit()}>
            Zamknij
          </Button>
        </Modal.Footer>
    </Modal>
    )
}